import React, { Component } from 'react';
import styled from 'styled-components';
import { Form, Slider } from 'antd';
import PropTypes from 'prop-types';
import isEqual from 'lodash.isequal';

const FormItem = Form.Item;

const Wrapper = styled.div`
  .ant-form-item-label label {
    color: white;
  }
`;

class StrokeWidthSelector extends Component {
  static propTypes = {
    strokeWidth: PropTypes.number,
  };

  static defaultProps = {
    strokeWidth: 1,
  };

  componentWillReceiveProps(nextProps) {
    if (!isEqual(this.props.strokeWidth, nextProps.strokeWidth)) {
      this.props.form.resetFields();
    }
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const { strokeWidth } = this.props;
    return (
      <Wrapper>
        <h2 style={{ color: 'white', marginTop: '5px' }}>LINE THICKNESS</h2>
        <Form onSubmit={this.handleSubmit} layout="vertical">
          <FormItem>
            {getFieldDecorator('width', {
              valuePropName: 'value',
              initialValue: strokeWidth,
            })(
              <Slider
                min={1}
                max={5}
                step={0.25}
                onChange={this.handleSubmit}
              />
            )}
          </FormItem>
        </Form>
      </Wrapper>
    );
  }
}

export default Form.create({
  onValuesChange: (props, value) => {
    props.onChange(value);
  },
})(StrokeWidthSelector);



// WEBPACK FOOTER //
// ./src/components/ChartView/StrokeWidthSelector.js